import { FC, use } from "react";
import LoginComponent from "@/PageComponents/Login/LoginComponent";
import useInitialTimeout from "@/hooks/useInitialTimeout";

const Login = (props: any, context: any) => {

    useInitialTimeout(0, () => {
        sessionStorage.setItem("hubspotFromLogin", "true");
    });

    return <>
        <LoginComponent />
    </>
}

export default Login